import React from 'react';
import styled from 'styled-components';
import { Host } from '../Host';
import { Colors } from '../ui';
import { useResolve } from './Container';
import { ProfileModel } from './ProfileModel';

const Frame = styled.div<{ color: string }>`
    position: absolute;
    z-index: 10000;
    right: 6rem;
    bottom: 1.25rem;
    padding: 0.9rem 1.5rem;

    background: ${p => p.color};
    border-radius: 1000rem;
    color: white;
    font-size: 1.125rem;
    font-weight: 500;
`;

export const DevelopmentInfo = () => {
    const { email, color } = useResolve(ProfileModel);
    return Host.env === 'whut' && <Frame color={color || Colors.primary}>
        {email}
    </Frame>;
};
